/**
 * PIEX Predictive Search - sin precio
 */
function piexSearchInit() {
  var input = document.querySelector('.piex-search-form input[type="search"]');
  var searchWrap = document.querySelector('.piex-header__search');
  if (!input || !searchWrap) return;

  searchWrap.style.position = 'relative';

  var dd = document.createElement('div');
  dd.style.cssText = 'position:absolute;top:calc(100% + 8px);left:0;right:0;background:#fff;border-radius:14px;box-shadow:0 8px 32px rgba(0,0,0,0.15);z-index:9999;max-height:440px;overflow-y:auto;display:none;border:1px solid #eee;';
  searchWrap.appendChild(dd);

  var timer = null;
  var lastQ = '';

  function go(q) {
    if (q === lastQ) return;
    lastQ = q;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=7')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var prods = (data.resources && data.resources.results && data.resources.results.products) || [];
        render(prods, q);
      }).catch(function() { dd.style.display = 'none'; });
  }

  function render(prods, q) {
    var h = '<div style="padding:8px 0;">';
    if (!prods.length) {
      h += '<div style="padding:14px 18px;color:#999;font-size:13px;">Sin resultados para &ldquo;' + q + '&rdquo;</div>';
    } else {
      h += '<div style="padding:6px 18px 4px;font-size:11px;font-weight:700;color:#bbb;text-transform:uppercase;letter-spacing:.08em;">Productos</div>';
      prods.forEach(function(p) {
        var img = p.image
          ? '<img src="' + p.image + '" style="width:48px;height:48px;object-fit:cover;border-radius:8px;flex-shrink:0;">'
          : '<div style="width:48px;height:48px;background:#f0f0f0;border-radius:8px;flex-shrink:0;"></div>';
        h += '<a href="' + p.url + '" style="display:flex;align-items:center;gap:12px;padding:10px 18px;text-decoration:none;color:#1a1a1a;border-bottom:1px solid #f5f5f5;" onmouseover="this.style.background=\'#f7f7f7\'" onmouseout="this.style.background=\'\'">';
        h += img + '<div style="font-size:13px;font-weight:500;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + p.title + '</div></a>';
      });
    }
    h += '<a href="/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bunavailable_products%5D=hide" style="display:flex;align-items:center;justify-content:center;padding:12px 18px;font-size:13px;font-weight:700;color:#00b89a;text-decoration:none;">Ver todos los resultados &rarr;</a>';
    h += '</div>';
    dd.innerHTML = h;
    dd.style.display = 'block';
  }

  function hide() { dd.style.display = 'none'; lastQ = ''; }

  input.addEventListener('input', function() {
    clearTimeout(timer);
    var q = this.value.trim();
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(function() { go(q); }, 200);
  });

  input.addEventListener('focus', function() {
    if (this.value.trim().length >= 2) go(this.value.trim());
  });

  document.addEventListener('click', function(e) {
    if (!searchWrap.contains(e.target)) hide();
  });

  input.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') hide();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', piexSearchInit);
} else {
  piexSearchInit();
}
